/* PDA — Flèches overlay discrètes des carrousels de menus (megas + panneau recherche)
   + suggestions de collections des catalogues (rangée .pda-context-collections__row —
   cascade contextuelle œuvres ET sélections page artistes, directive Sam 22/07 :
   « les mêmes qu'au hover du mega menu »).
   Retour Sam 19/07 : « au hover sur le carrousel, simplement faire apparaître des flèches
   par-dessus, discrètes » — tranche l'option molette/flèches laissée ouverte le 18/07.
   Enhancement pointeur/desktop UNIQUEMENT : la piste reste nativement scrollable
   (trackpad/drag) ; sans hover (tactile) rien n'est injecté.
   MÉCANIQUE : injection LAZY au premier survol du carrousel (host = parent direct de la
   piste .pda-mega__cards / .pda-psearch__row / .pda-context-collections__row, soit
   .pda-mega__featured / .pda-psearch__oeuvres / section.pda-context-collections — ce
   dernier porte l'edge-pad → offsets ramenés au bord de la piste côté CSS).
   Le panneau recherche re-rend son contenu en innerHTML (pda-predictive.js) : les boutons
   wipés se ré-injectent au survol suivant. AUCUN MutationObserver (guerre de mutations vs
   morph → renderer gelé, piège consigné _PIEGES-HORIZON 19/07). */
(() => {
  if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  /* ⚡ 08/08 — `.pda-artist-month__track` ajoutée : cote Sam, « EXACTEMENT comme dans les
     carousel du mega menu, ou les carousel de suggestion de collection ». On branche donc
     la piste sur CE mécanisme au lieu de recréer des flèches (mes deux tentatives
     précédentes ont dévié : mauvais composant, mauvais placement). Son host = le parent
     direct, `<pda-scroller class="pda-artist-month__scroller">`. */
  const TRACKS =
    '.pda-mega__cards, .pda-psearch__row, .pda-context-collections__row, .pda-artist-month__track';
  /* Glyphe = chevron-carousel de pda-icons (10×14, Figma 2172:100289) — inline car injecté JS. */
  const CHEVRON =
    '<svg width="10" height="14" viewBox="0 0 10 14" fill="none" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M3 11.5L8 7L3 2.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

  const step = (track) => {
    const card = track.firstElementChild;
    if (!card) return 360;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 10;
    return (card.getBoundingClientRect().width + gap) * 2; /* 2 cards par clic */
  };

  const syncEdges = (host, track) => {
    const max = track.scrollWidth - track.clientWidth;
    host.toggleAttribute('data-mcar-start', track.scrollLeft <= 1);
    host.toggleAttribute('data-mcar-end', track.scrollLeft >= max - 1);
    host.toggleAttribute('data-mcar-scrollable', max > 1);
  };

  const arm = (track) => {
    const host = track.parentElement;
    if (!host) return;
    /* 2 rangées togglées peuvent partager le même host (cascade catalogue 03/08) :
       la piste COURANTE vit sur host.__mcarTrack — boutons et syncEdges la lisent,
       jamais la closure du 1er armement (flèches mortes sur la 2e rangée, revue 03/08). */
    host.__mcarTrack = track;
    if (!track.__mcarWired) {
      track.__mcarWired = true;
      let rafT = 0;
      track.addEventListener('scroll', () => {
        if (rafT) return;
        rafT = requestAnimationFrame(() => {
          rafT = 0;
          if (host.__mcarTrack === track) syncEdges(host, track);
        });
      }, { passive: true });
    }
    if (host.hasAttribute('data-mcar-host')) { syncEdges(host, track); return; }
    host.setAttribute('data-mcar-host', '');
    /* Centre vertical = milieu de la zone IMAGE de la 1re card (repli : milieu de piste) —
       mesuré à l'injection, le carrousel est forcément visible (on le survole). */
    const ref = track.querySelector('[class*="__wrap"], img') || track;
    const r = ref.getBoundingClientRect();
    const mid = r.top + r.height / 2 - host.getBoundingClientRect().top;
    host.style.setProperty('--mcar-mid', Math.round(mid) + 'px');
    for (const dir of [-1, 1]) {
      const b = document.createElement('button');
      b.type = 'button';
      b.tabIndex = -1; /* enhancement pointeur — le chemin clavier reste la piste/les cards */
      b.className = 'pda-mcar-btn ' + (dir < 0 ? 'pda-mcar-btn--prev' : 'pda-mcar-btn--next');
      b.setAttribute('aria-label', dir < 0 ? 'Faire défiler vers la gauche' : 'Faire défiler vers la droite');
      b.innerHTML = CHEVRON;
      b.addEventListener('click', (e) => {
        e.preventDefault();
        const tr = host.__mcarTrack || track;
        tr.scrollBy({ left: dir * step(tr), behavior: 'smooth' });
      });
      host.appendChild(b);
    }
    syncEdges(host, track);
  };

  /* pointerover BULLE (contrairement à pointerenter) → délégation simple sur document. */
  document.addEventListener('pointerover', (e) => {
    const t = e.target;
    if (!(t instanceof Element)) return;
    const track = t.closest(TRACKS);
    if (track) arm(track);
  }, { passive: true });
})();
